import styled from 'styled-components'

const InputAdornmentElement = styled.div`
  font-weight: 500;
`

const InputAdornment = ({ children }) => (
    <InputAdornmentElement>{children}</InputAdornmentElement>
)

export { InputAdornment }
